import { useRef, useState } from 'react';
import type { ValidationError } from '../../format/validator';

interface ImportExportPanelProps {
  readonly onImport: (text: string) => readonly ValidationError[] | undefined;
  readonly onExport: () => string;
  readonly activePatternName: string;
}

export function ImportExportPanel(props: ImportExportPanelProps): JSX.Element {
  const [errors, setErrors] = useState<readonly ValidationError[] | undefined>(undefined);
  const inputRef = useRef<HTMLInputElement>(null);

  function handleFile(fileList: FileList | null): void {
    const file = fileList?.[0];
    if (!file) return;
    file
      .text()
      .then((text) => {
        const result = props.onImport(text);
        setErrors(result);
      })
      .catch(() => setErrors([{ path: '', code: 'file.read', message: 'Datei konnte nicht gelesen werden.' }]));
    if (inputRef.current) inputRef.current.value = '';
  }

  function handleExport(): void {
    const json = props.onExport();
    const blob = new Blob([json], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${props.activePatternName.replace(/[^A-Za-z0-9_-]+/g, '_') || 'sequenz'}.oibseq.json`;
    link.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div className="import-export-panel">
      <div className="import-export-row">
        <label className="file-import-label">
          JSON importieren
          <input ref={inputRef} type="file" accept="application/json,.json" onChange={(event) => handleFile(event.target.files)} />
        </label>
        <button type="button" onClick={handleExport}>
          JSON exportieren
        </button>
      </div>
      {errors && errors.length > 0 && (
        <div className="warning-list error">
          <h4>Import abgelehnt - aktueller Zustand bleibt erhalten</h4>
          <ul>
            {errors.map((error, index) => (
              <li key={index}>
                <code>{error.path || '/'}</code> [{error.code}] — {error.message}
              </li>
            ))}
          </ul>
        </div>
      )}
      {errors && errors.length === 0 && <p className="success">Import erfolgreich als neues Pattern uebernommen.</p>}
    </div>
  );
}
